var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticClass:"app-bar",attrs:{"dark":""}},[_c('v-spacer'),_c('div',{staticClass:"app-bar-logo__container"},[_c('img',{staticClass:"app-bar-logo",attrs:{"src":require("@/assets/kikusui_app_bar_logo.png"),"alt":"Logo"}})]),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }